 <!-- 我的发票 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的发票</p>
      </div>
    </div>
    <div class="nav-list" v-if="cur==1">
      <ul>
        <li class="type" :class="type==2?'cur':''" @click="onCur(2)">考试订单</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==1?'cur':''" @click="onCur(1)">课程订单</li>
      </ul>
    </div>
    <div class="order-type">
      <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;" @input="onButtons">
        <el-radio-button label="0">全部</el-radio-button>
        <el-radio-button label="1">未申请</el-radio-button>
        <el-radio-button label="2">待开票</el-radio-button>
        <el-radio-button label="3">已开票</el-radio-button>
      </el-radio-group>
    </div>
    <div class="order-item">
      <div class="order-item-top">
        <span class="order-item-top-left">订单信息</span>
        <div class="order-item-top-right">
          <span>订单金额</span>
          <span>开票状态</span>
          <span>订单操作</span>
        </div>
      </div>
      <ul class="order-item-ul">
        <li class="order-item-ul-li" v-for="item,index in orderList" :key="index">
          <p class="order-item-ul-li-number">订单编号：{{item.orderNum}}</p>
          <div class="order-item-ul-li-content">
            <div class="order-item-ul-li-content-img">
              <img :src="item.goodImg">
              <div>
                <p>{{item.goodName}}</p>
              </div>
            </div>
            <div class="order-item-ul-li-content-information">
              <div style="width: 100px;margin-top: 5px;">
                <p class="order-item-ul-li-content-information-moeny">￥{{item.payAmount}}</p>
                <p class="order-item-ul-li-content-information-time">{{item.payType==6 || item.payType==7?'支付宝':'微信'}}<br>{{item.payTime}}</p>
              </div>
              <p class="order-item-ul-li-content-information-type" v-if="item.orderInvoiceStatus==0">未开票</p>
              <p class="order-item-ul-li-content-information-type" v-else-if="item.orderInvoiceStatus==1">待开票</p>
              <p class="order-item-ul-li-content-information-type" v-else-if="item.orderInvoiceStatus==2">已开票</p>
              <div>
                <el-button class="buttonl" size="small" round style="border: 1px solid #f25e0a;color: #f25e0a;" v-if="item.orderInvoiceStatus==0" @click="onInvoiceApply(item.id)">申请开票</el-button>
                <el-button class="buttonl" size="small" round style="border: 1px solid #f25e0a;color: #f25e0a;width: 80px;" v-else-if="item.orderInvoiceStatus==3" @click="onInvoiceApply(item.id)">重新申请</el-button>
                <p style="width: 80px;" v-if="item.orderInvoiceStatus==1 || item.orderInvoiceStatus==2"></p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="rows"
        @current-change="currentChange">
      </el-pagination>
    </div>

    <div class="popup">
      <!-- 申请开票 -->
      <el-dialog title="" :visible.sync="dialogFormVisible">
        <p class="popup-title">申请开票</p>
        <div class="popup-form">
          <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label="发票类型：" label-width="120px">
              <div style="display: flex; justify-content: space-between;">
                <el-button style="width: 48.5%;height: 40px;" :class="types==1?'buttonss':'buttons'" size="small" :type="types==1?'warning':''" @click="onType(1)">电子普通发票</el-button>
                <el-button style="width: 48.5%;height: 40px; margin-left: 0;" :class="types==2?'buttonss':'buttons'" size="small" :type="types==2?'warning':''" @click="onType(2)">增值税专用发票</el-button>
              </div>
            </el-form-item>
            <el-form-item label="抬头类型：" label-width="120px" v-if="types==1">
              <div style="display: flex; justify-content: space-between;">
                <el-button style="width: 48.5%;height: 40px;" :class="status==1?'buttonss':'buttons'" size="small" :type="status==1?'warning':''" @click="onButton(1,'ruleForm')">个人</el-button>
                <el-button style="width: 48.5%;height: 40px; margin-left: 0;" :class="status==2?'buttonss':'buttons'" size="small" :type="status==2?'warning':''" @click="onButton(2,'ruleForm')">企业</el-button>
              </div>
            </el-form-item>
            <div v-if="status==1">
              <el-form-item label="发票抬头：" prop="invoiceHead" label-width="120px">
                <el-input v-model="ruleForm.invoiceHead" placeholder="请输入发票抬头"></el-input>
              </el-form-item>
              <el-form-item label="收件邮箱：" prop="receiveMail" label-width="120px">
                <el-input v-model="ruleForm.receiveMail" placeholder="请输入收件邮箱"></el-input>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item label="单位名称：" prop="applyName" label-width="120px">
                <el-input v-model="ruleForm.applyName" placeholder="请输入单位名称"></el-input>
              </el-form-item>
              <el-form-item label="纳税人识别码：" prop="taxerCode" label-width="120px">
                <el-input v-model="ruleForm.taxerCode" placeholder="请输入纳税人识别码"></el-input>
              </el-form-item>
              <el-form-item label="收件邮箱：" prop="receiveMail" label-width="120px">
                <el-input v-model="ruleForm.receiveMail" placeholder="请输入收件邮箱"></el-input>
              </el-form-item>
            </div>
            
            <el-form-item style="text-align: center;margin-top: 50px">
              <el-button size="small" type="warning" @click="submitForm('ruleForm')" style="padding: 14px 100px;background-color: #ff821c">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
    
  </div>
</template>

<script>
import { myOrder,invoiceApply } from '../../api/userMG'
export default {
  data() {
    return {
      cur:1,
      types:1,
      type:2,
      status:1,
      tabPosition: '0',
      dialogFormVisible:false,
      orderList:[],
      ruleForm:{
        orderId:'',
        invoiceHead:'',
        applyName:'',
        taxerCode: '',
        address: '',
        phone:'',
        bank:'',
        number: '',
        receiveMail: ''
      },
      rules: {
        invoiceHead: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        rise: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        applyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        taxerCode: [
          { required: true, message: '请输入纳税人识别码', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入注册电话', trigger: 'blur' }
        ],
        bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        receiveMail: [
          { required: true, message: '请输入收件邮箱', trigger: 'blur' }
        ]
      },
      page:1,
      rows:10,
      total:0,
    }
  },
  created() {
    this.getMyOrder()
  },
  methods:{
    // 获取订单列表
    async getMyOrder(){
      let params = {
        page:this.page,
        rows:this.rows,
        type:this.type,
        status:1,
        orderInvoiceStatus:this.tabPosition==0?'':this.tabPosition-1
      }
      await myOrder(params).then(res => {
        console.log('发票列表',res);
        this.orderList = res.data.content;
        this.total = res.data.total;
      })
    },
    onInvoiceApply(id){
      this.ruleForm.orderId = id;
      this.dialogFormVisible = true
    },
    onType(e){
      this.types = e;
      this.status = 2;
    },
    onCur(e){
      this.type = e;
      this.page = 1;
      this.getMyOrder()
    },
    onButtons(){
      this.getMyOrder();
    },
    currentChange(e){
      console.log(e)
      this.page = e;
      this.getMyCourse()
    },
    onButton(e,formName){
      this.status = e;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          let params = {
            orderId:this.ruleForm.orderId,
            invoiceType:this.types,
            applyType:this.status,
            invoiceHead:this.ruleForm.invoiceHead,
            applyName:this.ruleForm.applyName,
            taxerCode:this.ruleForm.taxerCode,
            receiveMail: this.ruleForm.receiveMail
          }
          invoiceApply(params).then(res => {
            console.log('申请成功',res);
            if(res.code == 0){
              this.$message({
                message: '提交成功！',
                type: 'warning',
                offset:100
              })
              this.getMyOrder();
              this.$refs[formName].resetFields();
            }
           
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  .nav-list{
    margin-top: 20px;
  }
  .nav-list ul{
    display: flex;
    align-items: center;
  }
  .nav-list ul li{
    font-size: 13px;
    padding: 10px 0;
    cursor: pointer;
  }
  .divider{
    margin:  0 40px;
  }
  .nav-list ul .bar{
    color: #e1e2e6;
  }
  .nav-list ul .type{
    color: black;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c;
  }
  .order-type{
    margin-top: 30px;
  }

  .el-radio-group{
    width: 100%;
  }
  .el-radio-button{
    width: 20%;
  }
  .order-type /deep/ .el-radio-button__inner{
    width: 100%;
    padding: 12px 0;
    color: black;
    font-size: 13px;
    background-color: #fafafa;
  }
  .order-type /deep/ .el-radio-button__inner:hover{
    color: black;
  }
  .order-type /deep/ .is-active .el-radio-button__inner{
    background-color: #ff821e;
    border-color: #ff821e;
    box-shadow: -1px 0 0 0 #ff821e;
    color: #fff;
  }

  .order-item{
    margin-bottom: 40px;
  }
  .order-item-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f1f1f1;
    padding: 0 18px 8px;
    margin-bottom:15px;
  }
  .order-item-top-left, .order-item-top-right span{
    font-size: 11px;
    color: #6c6c6c;
  }
  .order-item-top-right{
    width: 47%;
    padding-right: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .order-item-ul-li{
    border: 1px solid #eeeeee;
    margin-bottom: 18px;
  }
  .order-item-ul-li-number{
    padding: 10px 17px;
    background-color: #fafafa;
    font-size: 11px;
    color: #9d9d9d;
  }
  .order-item-ul-li-content{
    padding: 16px 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .order-item-ul-li-content-img{
    width: 50%;
    display: flex;
    align-items: center;
  }
  .order-item-ul-li-content-img img{
    width: 170px;
    border-radius: 4px;
    margin-right: 14px;
  }
  .order-item-ul-li-content-img p{
    font-size: 13px;
    color: #757575;
    width: 100px;
    line-height: 15px;
  }
  
  .order-item-ul-li-content-information{
    display: flex;
    justify-content: space-between;
    flex: 1;

  }
  .order-item-ul-li-content-information-moeny{
    font-size: 16px;
    color: #f15f09;
    font-weight: 600;
  }
  .order-item-ul-li-content-information-time{
    font-size: 12px;
    color: #9f9f9f;
    line-height: 14px;
    margin-top: 6px;
  }
  .order-item-ul-li-content-information-type{
    font-size: 12px;
    color: black;
    margin-top: 5px;
    width: 78px;
  }
  .pagination /deep/ .active{
    background: #ff821c !important;
  }
  /* .pagination /deep/ .number:hover{
    color: #ff821c !important;
  } */

  .pagination /deep/ .el-icon-d-arrow-left , .pagination /deep/ .el-icon-d-arrow-right{
    color: #ff821c !important;
  }
  .buttonl:hover{
    background: none;
  }
  .popup /deep/ .el-dialog__header{
    padding: 0;
  }
  .popup /deep/ .el-dialog__body{
    padding: 0;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 19px;
  }
   .popup /deep/ .el-dialog{
    border-radius: 8px;
  }
  .popup /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
  }

  .popup-title{
    background: #ff821e;
    color: #fff;
    font-size: 16px;
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .popup-form{
    padding: 40px 110px;
  }
  .buttons{
    color: #f35903;
    border:1px solid #f35903;
  }
  .buttons:hover{
    background: none;
  }
  .buttonss{
    background: #ff821c
  }
</style>


// WEBPACK FOOTER //
// src/views/invoice/invoice.vue